




import Vue from "vue";

import moment from "moment-timezone";

import {
  ContextMenuItem,
  ContextMenuItems,
} from "@/api/Termine";
import { Transaktion } from "@/api/Abrechnung";

export type PopoverMode = "edit" | "move-previous" | "move-next" | "select-date";

export interface MenuItemSelected {
  popoverMode: PopoverMode;
  kalendertag: string;
  dame: number;
  miete: number;
  kreuze: number;
}

export default Vue.extend({
  name: "MonatsabschlussEditContextMenu",
  data() {
    return {
      contextMenuEntries: [] as ContextMenuItems,
    };
  },
  methods: {
    open(kalendertagFormatted: string, anzahlTage: number, dame: number, miete: number) {
      const fn = (action: PopoverMode) => {
        return ((originalEvent: Event, item: ContextMenuItem) =>
          this.onSelectContextmenu(
            originalEvent,
            action,
            kalendertagFormatted,
            dame,
            miete
          )).bind(this);
      };
      const kalendertag = parseInt(kalendertagFormatted);

      this.contextMenuEntries = [];

      if (miete) {
        // Kontextmenü eines Tagesabschlusses
        // TODO: Berechtigungen prüfen
        if (kalendertag > 1) {
          this.contextMenuEntries.push(
            {
              label: "Summe/Kreuz auf vorigen Tag schieben",
              icon: "pi pi-fw pi-sort-amount-up",
              command: fn("move-previous"),
              visible: true,
            });
        }
        if (kalendertag < anzahlTage) {
          this.contextMenuEntries.push(
            {
              label: "Summe/Kreuz auf nächsten Tag schieben",
              icon: "pi pi-fw pi-sort-amount-down-alt",
              command: fn("move-next"),
              visible: true,
            });
        }
        this.contextMenuEntries.push(
          {
            label: "Summe/Kreuz auf anderen Tag schieben",
            icon: "pi pi-fw pi-sort-alt",
            command: fn("select-date"),
            visible: true,
          });
        this.contextMenuEntries.push(
          {
            label: "Einnahme manuell überschreiben",
            icon: "pi pi-fw pi-pencil",
            command: fn("edit"),
            visible: true,
          });
      } else {
        this.contextMenuEntries.push(
          {
            label: "Einnahme hier erfassen",
            icon: "pi pi-fw pi-pencil",
            command: fn("edit"),
            visible: true,
          });
      }

      const contextMenu: any = this.$refs.contextMenu;
      contextMenu.show(event);
    },

    // Auswahl eines Kontextmenü-Eintrags
    onSelectContextmenu(
      event: any,
      action: string,
      kalendertag: string,
      dame: number,
      miete: number
    ) {
      console.log(event);
      console.log(action);
      console.log(kalendertag);
      console.log(dame);
      console.log(miete);
      this.$emit("select", {
        popoverMode: action,
        kalendertag,
        dame,
        miete,
      } as MenuItemSelected);
    },
  },
});
